import { h, VNode, Fragment, ComponentChildren, FunctionComponent, toChildArray } from "preact"; /** @jsx h */
import { clsx } from 'clsx';

export type ISectionProps = {
    children?: ComponentChildren;
    weight: 'full' | 'equal' | 'left' | 'right' | 'bottom';
};


export const Section = (props: ISectionProps) => {

    const nonColumnsTop = toChildArray(props.children).filter((child: any) => child?.type?.name !== "Column" && child?.type?.name !== "Layout_Column" && child?.props?.weight !== "bottom");
    const nonColumnsBottom = toChildArray(props.children).filter((child: any) => child?.type?.name !== "Column" && child?.type?.name !== "Layout_Column" && child?.props?.weight === "bottom");
    const columns = toChildArray(props.children).filter((child: any) => child?.type?.name === "Column" || child?.type?.name === "Layout_Column");

    //console.log("Section: ", props, columns, columns.length);

    return (
        <div className={clsx("container", props.weight !== "full" && "pt-4 pb-4")}>
            <div style={{paddingBottom: "25px"}}>
            {
                // show all the children that are not Columns
                // at the top
                nonColumnsTop
            }
            </div>
            {
                columns.length > 0 && (
                    <div className="row">
                        {
                            columns.map((column: any, idx: number) => (
                                <div className={clsx(
                                    columns.length % 2 == 0 && props.weight === 'equal' && "col-lg-6",
                                    (props.weight === 'left' && idx % 2 == 0 || props.weight === 'right' && idx % 2 == 1) && "col-md-8",
                                    (columns.length % 2 == 1 || props.weight === 'left' && idx % 2 == 1 || props.weight === 'right' && idx % 2 == 0) && "col-md-4 pl-4",
                                )}>
                                    { column }
                                </div>
                            ))
                        }
                    </div>
                )
            }
            {
                // show all the children that are not Columns
                // at the top
                nonColumnsBottom
            }
            
        </div>

    );
}